import { ISearchableProperty, ISearchableLegacyProperty } from '.';

export const diProperties: ISearchableProperty[] = [
  { value: 'requestId', label: 'Request ID', searchable: true },
  { value: 'reqType', label: 'Request Type', searchable: true },
  { value: 'reqRole', label: 'Role', searchable: false },
  { value: 'createdAt', label: 'Created Date', searchable: true },
  { value: 'status', label: 'Status', searchable: true },
  // { value: 'sailpointCaseId', label: 'Case ID', searchable: true },
  { value: 'requestorEmail', label: 'Requester', searchable: false },
  { value: 'deaNumbers', label: 'DEA Numbers', searchable: true },
  { value: 'activeApproverEmail', label: 'Subscriber Information', searchable: false },
];

export const legacyProperties: ISearchableLegacyProperty[] = [
  { value: 'id', label: 'Request ID', searchable: true },
  { value: 'serialNumber', label: 'Serial Number', searchable: true },
  { value: 'reqType', label: 'Request Type', searchable: false },
  { value: 'reqRole', label: 'Role', searchable: false },
  { value: 'createdAt', label: 'Created Date', searchable: true },
  // { value: 'updatedAt', label: 'Updated Date', searchable: true },
  { value: 'status', label: 'Status', searchable: false },
  { value: 'subscriberInfo', label: 'Subscriber Information', searchable: false },
  // { value: 'sailpointCaseId', label: 'Case ID', searchable: true },
  { value: 'requestorEmail', label: 'Requester', searchable: false },
  { value: 'deaNumbers', label: 'DEA Numbers', searchable: true },
  { value: 'certificateEmail', label: 'Certificate Email', searchable: true },
];
